import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Mission } from './components/Mission';
import { Methodology } from './components/Methodology';
import { SuccessStories } from './components/SuccessStories';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <Hero data-id="element-2" />
      <Mission data-id="element-3" />
      <Methodology data-id="element-4" />
      <SuccessStories data-id="element-5" />
      <Contact data-id="element-6" />
      <Footer data-id="element-7" />
    </div>;
}